import type { CatalogCarouselItem } from '~/features/experiments/ab_plp_redesign_2025/models/catalog-carousel-item';

import { CATALOG_CTA_ANALYTICS_LABEL, CLAUDE_ENGINEER_ASSETS, COURSE_PATH, FLAG_VARIANT_LOGO } from '../constants';
import type { ClaudeEngineerVariant } from '../models/variant';

export function getCatalogClaudeEngineerCarouselItem(variant: ClaudeEngineerVariant): CatalogCarouselItem {
  const showLogo = variant === FLAG_VARIANT_LOGO;

  return {
    title: 'Learn AI Engineering\n**with Claude**',
    ctaLabel: 'Enroll Now',
    ctaUrl: COURSE_PATH,
    theme: 'claude-engineer',
    backgroundImage: CLAUDE_ENGINEER_ASSETS.catalogBannerBg,
    backgroundImageObjectPosition: { base: 'right bottom', md: 'center' },
    backgroundImageQuality: 100,
    ctaMarginTopAuto: true,
    entireCardClickable: true,
    key: `claude-engineer-nd7426-${variant}`,
    logoImage: showLogo ? CLAUDE_ENGINEER_ASSETS.claudeLogoCatalog : undefined,
    eventPayload: {
      type: 'click' as const,
      name: 'catalogCtaClicked',
      label: CATALOG_CTA_ANALYTICS_LABEL,
      value: 'nd7426',
    },
  };
}
